import React, { Fragment } from 'react'
import classNames from 'classnames'
import Avatar from '../Avatar'
import { twMerge} from 'tailwind-merge'

export const Person = ({ id, firstname = '', lastname = '', name: _name, email, image, type, className, chip = null, ...props }) => {
  const name = _name || firstname + ' ' + lastname
  const initials = name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase()

  return (
    <div className={classNames(twMerge('inline-block flex items-center gap-2', className))}>
      <Avatar
        size="base"
        initials={initials}
        src={image}
      />

      <div>
        <h1 className="leading-tight">{ name }</h1>

        { email ? (
          <a
            className="text-sm text-primary hover:text-primary-darker leading-tight"
            href={`mailto:${email}`}
          >{ email }</a>
        ) : (
          <span className="text-sm text-gray-300 leading-tight">
            No e-mail available
          </span>
        ) }
      </div>

      { chip &&
        <Fragment>{ chip }</Fragment>
      }
    </div>
  )
}

export default Person
